import { RoleName } from '@m/types/api/iam/Iam';

import { hasRoles } from './iamRoles';

/**
 * Returns whether the current Keycloak session includes Super Admin (IAM client roles).
 */
export function useSuperAdminCheck(): boolean {
  return hasRoles([RoleName.SUPER_ADMIN]);
}
